// extracted by mini-css-extract-plugin
export default {"form-container":"form_form-container__VVPLD","line-text":"form_line-text__SxkIa"};